<template>
  <section>
    <b-row class="content-header">
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="12"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h2 class="content-header-title float-left pr-1 mb-0">
              Home
            </h2>
            <div class="breadcrumb-wrapper">
              <b-breadcrumb>
                <b-breadcrumb-item to="/">
                  <feather-icon
                    icon="HomeIcon"
                    size="16"
                    class="align-text-top"
                  />
                </b-breadcrumb-item>
                <b-breadcrumb-item to="/measurables-manage">
                  Measurables
                </b-breadcrumb-item>
                <b-breadcrumb-item active>
                  Tracking Code
                </b-breadcrumb-item>
              </b-breadcrumb>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12" cols="12">
        <b-card no-body>
          <b-card-header class="align-items-baseline pb-1">
            <div>
              <b-card-title class="mb-25">
                JavaScript Tracking
              </b-card-title>
            </div>
          </b-card-header>
          <b-card-body>
            <div>
              Insert the below tracking code into the header (<strong>&lt;head&gt;</strong>) of your website, or each page that you want to track.<br><br>
              If you want to track specific user behaviour or a custom booking engine, please <a href="mailto:hello@hostmatic.io">email us </a>for a quote.
            </div>
            <div class="mt-2">
              <b-card-title>
                Website
              </b-card-title>
              <b-form-select
                v-model="tracking.idSite"
                :options="$store.state.app.allSites"
                value-field="idsite"
                text-field="label"
                clearable
              />
            </div>
            <div class="mt-2">
              <b-card-title>
                Options
              </b-card-title>
            </div>
            <b-row class="mt-2">
              <b-col md="6">
                <b-form-checkbox v-model="tracking.mergeSubdomains">
                  Track visitors across all subdomains of {{ url_domain }}
                </b-form-checkbox>
              </b-col>
              <b-col md="6">
                <b-alert variant="primary" show>
                  <div class="alert-body">
                    <span>So if one visitor visits x.{{ url_domain }} and y.{{ url_domain }}, they will be counted as a unique visitor.</span>
                  </div>
                </b-alert>
              </b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col md="6">
                <b-form-checkbox v-model="tracking.groupPageTitlesByDomain">
                  Prepend the site domain to the page title when tracking
                </b-form-checkbox>
              </b-col>
              <b-col md="6">
                <b-alert variant="primary" show>
                  <div class="alert-body">
                    <span>So if someone visits the 'About' page on blog.{{ url_domain }} it will be recorded as 'blog / About'. This is the easiest way to get an overview of your traffic by sub-domain.</span>
                  </div>
                </b-alert>
              </b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col md="6">
                <b-form-checkbox v-model="tracking.mergeAliasUrls">
                  In the "Outlinks" report, hide clicks to known alias URLs of {{ url_domain }}
                </b-form-checkbox>
              </b-col>
              <b-col md="6">
                <b-alert variant="primary" show>
                  <div class="alert-body">
                    <span>So clicks on links to Alias URLs (eg. x.{{
                        url_domain
                      }}) will not be counted as "Outlink".</span>
                  </div>
                </b-alert>
              </b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col md="6">
                <b-form-checkbox v-model="tracking.trackNoScript">
                  Track users with JavaScript disabled
                </b-form-checkbox>
              </b-col>
              <b-col md="6">
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="6">
                <b-form-checkbox v-model="tracking.doNotTrack">
                  Enable client side DoNotTrack detection
                </b-form-checkbox>
              </b-col>
              <b-col md="6">
                <b-alert variant="primary" show>
                  <div class="alert-body">
                    <span>So tracking requests will not be sent if visitors do not wish to be tracked.
Note: Server side DoNotTrack support has been enabled, so this option will have no effect.</span>
                  </div>
                </b-alert>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="6">
                <b-form-checkbox v-model="tracking.disableCookies">
                  Disable all tracking cookies
                </b-form-checkbox>
              </b-col>
              <b-col md="6">
                <b-alert variant="primary" show>
                  <div class="alert-body">
                    <span>Disables all first party cookies. Existing Matomo cookies for this website will be deleted on the next page view.</span>
                  </div>
                </b-alert>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="6">
                <b-form-checkbox v-model="useCustomQuery">
                  Use custom query parameter names for the campaign name & keyword
                </b-form-checkbox>
              </b-col>
              <b-col md="6">
                <b-alert variant="primary" show>
                  <div class="alert-body">
                    <span>Note: hostmatic will automatically detect Google Analytics parameters.</span>
                  </div>
                </b-alert>
              </b-col>
            </b-row>
            <b-row v-if="useCustomQuery">
              <b-col md="6">
                <b-form-group
                  label="Campaign Name parameter"
                  label-for="customCampaignNameQueryParam"
                >
                  <b-form-input
                    id="customCampaignNameQueryParam"
                    v-model="tracking.customCampaignNameQueryParam"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="useCustomQuery">
              <b-col md="6">
                <b-form-group
                  label="Campaign Keyword parameter"
                  label-for="customCampaignKeywordParam"
                >
                  <b-form-input
                    id="customCampaignKeywordParam"
                    v-model="tracking.customCampaignKeywordParam"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mt-3" v-if="tag">
              <b-col md="12">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary" @click="copy">
                  Copy to Clipboard
                </b-button>
                <b-alert variant="primary" show>
                  <div class="alert-body">
                    <pre style="background-color: #EEEDFD">{{ tag }}</pre>
                  </div>
                </b-alert>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import api from '@/libs/axios'
import { hmError } from '@/libs/toastification'

export default {
  name: 'tracking_code',
  data() {
    return {
      tracking: {
        idSite: null,
        mergeSubdomains: false,
        groupPageTitlesByDomain: false,
        mergeAliasUrls: false,
        trackNoScript: false,
        doNotTrack: false,
        disableCookies: false,
        customCampaignNameQueryParam: null,
        customCampaignKeywordParam: null
      },
      useCustomQuery: false,
      tag: null
    }
  },
  computed: {
    url_domain() {
      if (!this.tracking.idSite) return ''
      const site = this.$store.state.app.allSites.find(it => it.idsite === this.tracking.idSite)
      if (!site) return ''
      const d = new URL(site.main_url)
      return d.hostname
    },
    track_changes() {
      return `${this.tracking.idSite}|${this.tracking.mergeSubdomains}|${this.tracking.groupPageTitlesByDomain}|${this.tracking.mergeAliasUrls}|${this.tracking.trackNoScript}
      |${this.tracking.doNotTrack}|${this.tracking.disableCookies}|${this.tracking.customCampaignNameQueryParam}|${this.tracking.customCampaignKeywordParam}`
    }
  },
  watch: {
    track_changes() {
      this.getJavaScriptTag()
    }
  },
  methods: {
    getJavaScriptTag() {
      if (!this.tracking.idSite) {
        this.tag = null
        return
      }
      api.post('/api/matomo/site/getJavascriptTag', { tag: this.tracking }).then(r => {
        if (r.data.code !== 'Ok') return hmError('Error generating Tracking Code')
        this.tag = r.data.tag
      })
    },
    copy() {
      this.$copyText(this.tag).then(r => {
        console.log(r)
      }, (err) => {
        console.log(err)
      })
    }
  },
  mounted() {
    if (this.$store.state.app.allSites.length) {
      this.tracking.idSite = this.$route.query.idSite ?? this.$store.state.app.allSites[0].idsite
    }
  }
}
</script>
